import { useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import { Box } from "@mui/material";
import useCounterStore from "../../store/store";
import { getLocalItem, setLocalItem } from "../../utils/helpers";

const DepositButton = () => {
  const { walletAmt, setWalletAmt } = useCounterStore((state) => state);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [reChargeWallet, setReChargeWallet] = useState<number>(0);

  useEffect(() => {
    const check = getLocalItem("depositAmt");
    if (!check && walletAmt && walletAmt > 0) {
      setLocalItem("depositAmt", walletAmt);
    } else {
      setWalletAmt(Number(check));
    }
  }, [walletAmt]);

  const handleDeposit = () => {
    setOpenModal(!openModal);
  };

  const handleAddWalletAmt = () => {
    const newWalletAmt: number = Number(reChargeWallet) + walletAmt;
    setLocalItem("depositAmt", newWalletAmt);
    setWalletAmt(Number(newWalletAmt));
    setOpenModal(!openModal);
  };

  return (
    <div>
      <button
        className={`btn btn-bet modalBtn `}
        type="button"
        onClick={handleDeposit}
      >
        Deposit
      </button>

      <CustomModal
        open={openModal}
        setOpen={setOpenModal}
        autoClose={false}
        children={
          <Box className="wallet-modal">
            <div className="wallet-content">
              <div className="input-wrapper">
                <input
                  type="text"
                  placeholder="Enter Amount"
                  className="wallet-input"
                  onChange={(e) => setReChargeWallet(Number(e.target.value))}
                />
              </div>

              <button
                className={`btn btn-bet modalBtn mt_8 `}
                type="button"
                onClick={handleAddWalletAmt}
              >
                Submit
              </button>
            </div>
          </Box>
        }
      />
    </div>
  );
};

export default DepositButton;
